import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './header';
import { Footer } from './footer';
import { LoadingLayout } from '@/components/layout/Loading.layout';
import { useAuth, useInit, useModal } from '@/hooks';
import { Modal } from '../shared';
import ModalBox from '@/views/home/airdrop-home/ModalBox';
import { Trans, useTranslation } from 'react-i18next';

export function AppLayout() {
  const { isAuthenticated } = useAuth();
  const { initialize, isLoading } = useInit();
  const { id, showModal } = useModal();
  const { t } = useTranslation();
  const setLocalStorage = () => {
    // set airdrop-modal-showed to expiration date of 1 day
    const currentLocalStorage = localStorage.getItem('airdrop-modal-showed');
    // if current local storage expired, set new expiration date
    const newExpirationNeeded = currentLocalStorage
      ? new Date(currentLocalStorage) < new Date()
      : true;

    if (newExpirationNeeded) {
      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 1);
      // new date's minutes and seconds are set to 0
      expirationDate.setMinutes(0, 0, 0);
      localStorage.setItem('airdrop-modal-showed', expirationDate.toISOString());
    }
  };

  useEffect(() => {
    initialize().then();
  }, [isAuthenticated]);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      const showModalExpiration = localStorage.getItem('airdrop-modal-showed');
      const shouldShowModal = !showModalExpiration || new Date(showModalExpiration) < new Date();

      if (shouldShowModal) {
        setLocalStorage();
        showModal(id);
      }
    }, 1000);

    return () => clearTimeout(timeOut);
  }, [showModal]);

  return isLoading ? (
    <LoadingLayout />
  ) : (
    <div className='h-full min-h-screen flex flex-col'>
      <Header />
      <main className='flex-1'>
        <Modal
          // onClose={setLocalStorage}
          id={id}
          className='!p-0 !max-w-3xl !w-full !bg-transparent !rounded-2xl'
        >
          <div
            style={{
              backgroundImage: 'url("airdrop-background.png")',
            }}
            className='w-full bg-[#191919] flex flex-col items-center py-5 lg:pt-8 lg:pb-12'
          >
            <div>
              <div className='font-semibold text-2xl text-[#FFDA68] ml-10 -mb-2'>{t('Join')}</div>
              <img src='/airdrop-logo.svg' className='h-24' alt='airdrop' />
            </div>

            <div className='mt:3.5 lg:mt-6 text-center px-4'>
              {t('$MIDLE token is coming. Secure your spot to earn Airdrop!')}
            </div>

            <div className='flex flex-col lg:flex-row items-center space-y-2 lg:space-x-2 mt-3.5 lg:mt-7'>
              <ModalBox>
                <Trans
                  i18nKey='Complete <bold>Tasks</bold>'
                  components={{
                    bold: <div className='font-bold' />,
                  }}
                />
              </ModalBox>

              <img className='rotate-90 lg:rotate-0' src='/double-arrow-right.svg' />

              <ModalBox>
                <Trans
                  i18nKey='<p>Earn <bold>MXP</bold></p> Rewards'
                  components={{
                    p: <p />,
                    bold: <span className='font-bold' />,
                  }}
                />
              </ModalBox>

              <img className='rotate-90 lg:rotate-0' src='/double-arrow-right.svg' />

              <ModalBox>
                <Trans
                  i18nKey='Get <bold>$MIDLE Airdrop</bold>'
                  components={{
                    bold: <div className='font-bold' />,
                  }}
                />
              </ModalBox>
            </div>

            <a
              href={isAuthenticated ? '/airdrop-home' : '/airdrop'}
              className='mt-12 w-52 h-14 p-0.5 text-[28px] hover:brightness-75 transition-all'
              style={{
                background:
                  'linear-gradient(135deg, transparent 12px, #FFDA68 calc(10% - 24px), #FFDA68 95%, transparent 12px)',
              }}
            >
              <div
                className='w-full h-full p-0.5'
                style={{
                  background:
                    'linear-gradient(135deg, transparent 12px, #151515 calc(10% - 24px), #151515 95%, transparent 12px)',
                }}
              >
                <div
                  className='w-full h-full text-[#151515] flex items-center justify-center font-black'
                  style={{
                    background:
                      'linear-gradient(135deg, transparent 12px, #FFDA68 calc(10% - 24px), #FFDA68 95%, transparent 12px)',
                  }}
                >
                  {t('Join Now')}
                </div>
              </div>
            </a>

            {/* <button className='p-3 bg-red-500 text-[#191919] rounded-lg'>Complete</button> */}
          </div>
        </Modal>

        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
